(function autoCloseDetails() {
  // Prevent redundant inline style writes from causing mutation/repaint loops.
  (function dedupeInlineStyleWrites() {
    if (!window.CSSStyleDeclaration || !CSSStyleDeclaration.prototype) return;
    if (CSSStyleDeclaration.prototype.__bmDedupePatched) return;

    var nativeSetProperty = CSSStyleDeclaration.prototype.setProperty;
    CSSStyleDeclaration.prototype.setProperty = function(name, value, priority) {
      try {
        var nextValue = String(value);
        var nextPriority = String(priority || '');
        if (this.getPropertyValue(name) === nextValue && this.getPropertyPriority(name) === nextPriority) {
          return;
        }
      } catch (_err) {
        // Fall through to native setter.
      }
      return nativeSetProperty.call(this, name, value, priority);
    };
    CSSStyleDeclaration.prototype.__bmDedupePatched = true;
  })();

  document.addEventListener('click', function (event) {
    const detailsToClose = [...document.querySelectorAll('details[data-auto-close-details][open]')].filter(
      (element) => {
        const closingOn = window.innerWidth < 750 ? 'mobile' : 'desktop';
        return (
          element.getAttribute('data-auto-close-details')?.includes(closingOn) &&
          !(event.target instanceof Node && element.contains(event.target))
        );
      }
    );

    for (const detailsElement of detailsToClose) detailsElement.removeAttribute('open');
  });

})();
